import { React } from 'react';
import {
  MonthlyBar,
  SidebarStyle,
  ColumnStyle,
  ColumnOneStyle,
  SoldTextStyle,
  RowStyle,
  SidebarMonthText,
} from '@atoms/sidebar/sidebar.styles';
import { MotifChip } from '@ey-xd/motif-react';
import {
  formatNumberWithKAndM,
  uppercaseFirstLetter,
  formatVarianceWithKAndM,
} from '@util/commonUtil';
import { useRecoilValue } from 'recoil';
import { Recoil_Quarter_State } from '@recoil/recoil';
import { CHIP, MONTH_QUARTER_STATUS, PERIOD, QUARTERLY_DETAILS } from '@constants/commonConstants';

const MonthlySidebar = props => {
  const propsData = props.propsData;
  const monthDataInfo = props.quarterData['months'];
  const quarterDataInfo = props.quarterData['quarterlyCalculation'];
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  let month;
  const pageUrl = window.location.pathname;

  month = propsData?.month;
  if (month !== undefined) month = month.charAt(0).toUpperCase() + month.slice(1);

  const getValue = (value, tag) => {
    if (tag === MONTH_QUARTER_STATUS.NOT_APPLICABLE) {
      return QUARTERLY_DETAILS.NOT_APPLICABLE;
    } else {
      return formatNumberWithKAndM(value) || '0 K';
    }
  };

  const getVarianceValue = (sold, commit, tag) => {
    if (tag === MONTH_QUARTER_STATUS.NOT_APPLICABLE) {
      return QUARTERLY_DETAILS.NOT_APPLICABLE;
    } else {
      return formatVarianceWithKAndM(sold - commit) || '0 K';
    }
  };

  return (
    <>
      {!!monthDataInfo && !!quarterInfo ? (
        <MonthlyBar aria-live="polite">
          {monthDataInfo.map(item => (
            <SidebarStyle key={item.month}>
              <ColumnOneStyle>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <SidebarMonthText className={!quarterDataInfo ? 'beyond-text-only' : null}>
                    {' '}
                    {uppercaseFirstLetter(item.month).slice(0, 3)}
                  </SidebarMonthText>

                  {!!quarterInfo &&
                  uppercaseFirstLetter(item.month).slice(0, 3) === quarterInfo.month &&
                  pageUrl !== '/forecast/past' ? (
                    <div>
                      <MotifChip
                        style={{
                          backgroundColor: '#ffe600',
                          color: '#0000000',
                        }}
                      >
                        {CHIP.CURRENT}
                      </MotifChip>
                    </div>
                  ) : null}

                  {uppercaseFirstLetter(item.month).slice(0, 3) !== quarterInfo.month &&
                  item?.calculation?.period === PERIOD.FUTURE &&
                  pageUrl !== '/forecast/past' ? (
                    <div>
                      <MotifChip style={{ backgroundColor: '#1a1a24', color: '#fff' }}>
                        {CHIP.FUTURE}
                      </MotifChip>
                    </div>
                  ) : null}
                </div>
              </ColumnOneStyle>

              {item?.calculation?.period === PERIOD.PAST && (
                <ColumnStyle>
                  {' '}
                  <RowStyle>
                    <SoldTextStyle>{QUARTERLY_DETAILS.FORECAST}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.commit, item?.calculation?.tag)}</span>
                </ColumnStyle>
              )}

              {item?.calculation?.period === PERIOD.PAST && (
                <ColumnStyle>
                  {' '}
                  <RowStyle>
                    <SoldTextStyle>{QUARTERLY_DETAILS.WON}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.sold, item?.calculation?.tag)}</span>
                </ColumnStyle>
              )}

              {item?.calculation?.period === PERIOD.PAST && (
                <ColumnStyle>
                  {' '}
                  <RowStyle>
                    <SoldTextStyle>{QUARTERLY_DETAILS.VARIANCE}</SoldTextStyle>
                  </RowStyle>
                  <span>
                    {getVarianceValue(
                      item?.calculation?.sold,
                      item?.calculation?.commit,
                      item?.calculation?.tag,
                    )}
                  </span>
                </ColumnStyle>
              )}

              {/* For Current Month */}
              {item?.calculation?.period === PERIOD.CURRENT && (
                <ColumnStyle>
                  {' '}
                  <RowStyle>
                    <SoldTextStyle>{QUARTERLY_DETAILS.CURRENT_COMMIT}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.commit, item?.calculation?.tag)}</span>
                </ColumnStyle>
              )}

              {/* For Future Month */}
              {item?.calculation?.period === PERIOD.FUTURE ? (
                pageUrl !== '/forecast/past' ? (
                  <ColumnStyle>
                    {' '}
                    <RowStyle>
                      <SoldTextStyle>{QUARTERLY_DETAILS.PROJECTED_FORECAST}</SoldTextStyle>
                    </RowStyle>
                    <span>{getValue(item?.calculation?.commit, item?.calculation?.tag)}</span>
                  </ColumnStyle>
                ) : (
                  <>
                    <ColumnStyle>
                      {' '}
                      <RowStyle>
                        <SoldTextStyle>{QUARTERLY_DETAILS.FORECAST}</SoldTextStyle>
                      </RowStyle>
                      <span>{getValue(item?.calculation?.commit, item?.calculation?.tag)}</span>
                    </ColumnStyle>
                    <ColumnStyle>
                      {' '}
                      <RowStyle>
                        <SoldTextStyle>{QUARTERLY_DETAILS.WON}</SoldTextStyle>
                      </RowStyle>
                      <span>{getValue(item?.calculation?.sold, item?.calculation?.tag)}</span>
                    </ColumnStyle>
                    <ColumnStyle>
                      {' '}
                      <RowStyle>
                        <SoldTextStyle>{QUARTERLY_DETAILS.VARIANCE}</SoldTextStyle>
                      </RowStyle>
                      <span>
                        {getVarianceValue(
                          item?.calculation?.sold,
                          item?.calculation?.commit,
                          item?.calculation?.tag,
                        )}
                      </span>
                    </ColumnStyle>
                  </>
                )
              ) : null}

              {quarterDataInfo &&
              item?.calculation?.period !== PERIOD.PAST &&
              pageUrl !== '/forecast/past' ? (
                <ColumnStyle>
                  <RowStyle>
                    <SoldTextStyle>{QUARTERLY_DETAILS.UNCOMMITED_PIPELINE}</SoldTextStyle>
                  </RowStyle>
                  <span>{getValue(item?.calculation?.noCommit, item?.calculation?.tag)}</span>
                </ColumnStyle>
              ) : null}
            </SidebarStyle>
          ))}
        </MonthlyBar>
      ) : null}
    </>
  );
};

export default MonthlySidebar;
